import { deepCopyClassName, IoCContainer, IUtils, WebCoreIoCKeys } from '..';
import { SidebarModule } from './sidebar-module.class';

export enum SidebarSide {
    Left = 'left',
    Right = 'right',
    Top = 'top',
    Bottom = 'bottom',
}

export const SIDEBAR_MAX_SIZE_RATIO = 0.6;

export class Sidebar {
    constructor(sidebarJSObj?: any) {
        let utils: IUtils = IoCContainer.get(WebCoreIoCKeys.IUtils);
        if (sidebarJSObj != null) {
            utils.deepCopy(this, sidebarJSObj);
        } else {
            this.orientation = SidebarSide.Left;
            this.size = 200;
            this.sidebarModuleList = [];
        }
    }

    public orientation: SidebarSide;
    public size: number;

    @deepCopyClassName(SidebarModule)
    public sidebarModuleList: SidebarModule[];
}
